<template>
    <div :class="classes({ active })" :style="{ color: this.parent[active ? 'activeColor' : 'inactiveColor'] }" @click="onClick">
        <div :class="classes('icon', { dot: this.dot })">
          <slot name="icon" :active="active">
              <h-icon :type="icon"/>
          </slot>
          <h-info v-if="info" :info="info" />
        </div>
        <div :class="classes('text')">
            <slot :active="active"></slot>
        </div>
      </div>
</template>
<script>
import { classesMixin } from "../../../common/mixins/classname";
import { ChildrenMixin } from "../../../common/mixins/relation";
import hIcon from '../../icon/index';
import hInfo from '../../info/index';
let classMixin = classesMixin("tabbar-item");
export default {
    name: 'h-tabbar-item',
    mixins: [classMixin, ChildrenMixin("hanzoTabbar")],
    props: {
        icon: String,
        dot: Boolean,
        info: [String, Number]
    },

    components: {
        hIcon, hInfo
    },

    data() {
        return {
            active: false
        };
    },

    methods: {
        onClick(event) {
            this.parent.onChange(this.index);
            this.$emit('click', event);
        }
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>